export const uncorrect = 'Password must contain at least 8 characters, uppercase and lowercase letters, and numbers';
export const wrongEmail = 'wrong e-mail address';
export const mismatch = 'passwords do not match';
export const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
export const emailRegEx = /^\w+@\w+\.\w+$/;
